import React, { useState } from 'react';
import Tab from './Tab';
import './Tabs.scss';
import { useQuery } from "hooks/useQuery";
import { useHistory } from "react-router-dom";

const Tabs = ({ children }) => {
  const query = useQuery();
  const history = useHistory();
  const [ activeTab, setActiveTab ] = useState(query.get('tab') || children[0].props.label);

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
    history.push(`?tab=${ tab }`);
  }

  return (
    <div className="tabs">
      <nav className="tabs__nav">
        {
          children?.map(
            child => {
              const { label } = child?.props;

              return (
                <Tab
                  activeTab={ activeTab }
                  key={ label }
                  label={ label }
                  onClick={ onClickTabItem }
                />
              );
            }
          )
        }
      </nav>
      <div className="tab">
        {
          children?.map(
            child => {
              if (child?.props?.label !== activeTab) return null;
              return child.props.children;
            }
          )
        }
      </div>
    </div>
  );
}

export default Tabs;
